import { setSelected } from "../redux/slices/selectedTariff";
import { store } from "../redux/store";
// Функция для вычисления итоговой суммы с учетом процентных ставок
export var calculateFinalSum = function (sum, percentages) {
    return percentages.reduce(function (total, percent) { return total + total * (percent / 100); }, sum);
};
export function pickTariff(tariffs, initialSum) {
    if (tariffs.length === 0) {
        return null;
    }
    return tariffs.reduce(function (bestTariff, currentTariff) {
        // Извлекаем проценты текущего тарифа
        var currentPrcValues = currentTariff.periodPercent;
        var currentFinalSum = calculateFinalSum(initialSum, currentPrcValues);
        // Извлекаем проценты лучшего тарифа
        var bestPrcValues = (bestTariff === null || bestTariff === void 0 ? void 0 : bestTariff.periodPercent) ? bestTariff.periodPercent : [0];
        var bestFinalSum = calculateFinalSum(initialSum, bestPrcValues);
        // Выбираем тариф с минимальной итоговой суммой
        if (bestTariff === null || currentFinalSum < bestFinalSum) {
            store.dispatch(setSelected(currentTariff));
            return currentTariff;
        }
        store.dispatch(setSelected(bestTariff));
        return bestTariff;
    }, null);
}
